// SchoolInfo.jsx
import React, { useContext, useEffect, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import UpperbarContext from "../../../context/upperbar-context";
import AuthContext from "../../../context/auth-context";
import { Fetchdata } from "../../../hooks/getData";
import { FaRegSave, FaSyncAlt } from "react-icons/fa";
import { FaRegCalendarAlt } from "react-icons/fa";
import placeholderLogo from "../../../../images/placeholder.png"; // adjust path

export default function SchoolInfo({ companyId = "ES25", onSaveSuccess }) {
  const { mode, darkText ,fiscalYear, appURL, expires, todayDate} = useContext(UpperbarContext);
  const { User } = useContext(AuthContext);

  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [formData, setFormData] = useState({
    Logo: "",
    ComName: "",
    Address: "",  
    Latitude: "",
    Longitude: "",
    Website: "",
    Fb: "",
    Email: "",
    Tel: "",
    MobNumber: "",
    DistrictID: "",
    SSFNo: "",
    ProvFund: "",
  });
  const [formErrors, setFormErrors] = useState({});

  // District options (matching the API's DistrictID)
  const districtOptions = [
    { id: 1, name: "Kathmandu" },
    { id: 2, name: "Lalitpur" },
    { id: 3, name: "Bhaktapur" },
    { id: 4, name: "Pokhara" },
    { id: 5, name: "Chitwan" },
    { id: 6, name: "Bharatpur" },
    { id: 7, name: "Birgunj" },
    { id: 8, name: "Biratanagar" },
    { id: 9, name: "Janakpur" },
    { id: 10, name: "Nagarjun" },
  ];

  useEffect(() => {
    if (User?.AuthCode && companyId) {
      fetchSchoolData();
    }
  }, [companyId, User]);

  const fetchSchoolData = () => {
    setLoading(true);
    const payload = {
      AuthCode: User.AuthCode,
      UserID: User.UID.toString(),
      ComID: companyId,
      Flag: "SI",
      FetchURL: `${appURL}api/admin/com-info`,
      Type: "POST",
    };

    Fetchdata(payload)
      .then((res) => {
        if (res.StatusCode === 200 && res.Values?.length) {
          const data = res.Values[0];
          setFormData({
            Logo: data.Logo || "",
            ComName: data.ComName || "",
            Address: data.Address || "",
            DistrictID: data.DistrictID?.toString() || "",
            Email: data.Email || "",
            Tel: data.Tel || "",
            MobNumber: data.MobNumber || "",
            Website: data.Website || "",
            Fb: data.Fb || "",
            Latitude: data.ComLat || "",
            Longitude: data.ComLong || "",
            SSFNo: data.SSFNo || "",
            ProvFund: data.ProvidentFund || "",
            ExpiryDate:data.ExpiryDate||""
        
         
          });
        } else {
          toast.error(res.Message || "Failed to load company data");
        }
      })
      .catch((err) => {
        console.error(err);
        toast.error("Network error while fetching data");
      })
      .finally(() => setLoading(false));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    if (formErrors[name]) {
      setFormErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };

  const validateForm = () => {
    const errors = {};
    if (!formData.ComName.trim()) errors.ComName = "Company Name is required";
    if (!formData.Address.trim()) errors.Address = "Address is required";
    if (!formData.DistrictID) errors.DistrictID = "District is required";
    if (formData.Email && !/^\S+@\S+\.\S+$/.test(formData.Email))
      errors.Email = "Invalid email format";
    return errors;
  };

  const handleSave = () => {
    const errors = validateForm();
    if (Object.keys(errors).length) {
      setFormErrors(errors);
      toast.error("Please fix validation errors");
      return;
    }

    setSaving(true);
    const payload = {
      AuthCode: User.AuthCode,
      UserID: User.UID.toString(),
      ComID: companyId,
      Flag: "U",
      Address: formData.Address,
      DistrictID: formData.DistrictID,
      Email: formData.Email,
      Tel: formData.Tel,
      Website: formData.Website,
      Fb: formData.Fb,
      Latitude: formData.Latitude,
      Longitude: formData.Longitude,
      SSFNo: formData.SSFNo,
      ProvFund: formData.ProvFund,
      FetchURL: `${appURL}api/admin/com-info`,
      Type: "POST",
    };

    Fetchdata(payload)
      .then((res) => {
        if (res.StatusCode === 200) {
          toast.success("Company information updated successfully");
          if (onSaveSuccess) onSaveSuccess();
          fetchSchoolData(); // refresh after save
        } else {
          toast.error(res.Message || "Update failed");
        }
      })
      .catch((err) => {
        console.error(err);
        toast.error("Network error while saving");
      })
      .finally(() => setSaving(false));
  };

  if (loading) {
    return (
      <div className="text-center py-5">
        <div className="spinner-border text-primary" role="status" />
        <p className="mt-2">{mode === "en" ? "Loading company data..." : "विद्यालय डाटा लोड हुँदै..."}</p>
      </div>
    );
  }

  return (
    <div className="container-fluid classatten-wrapper  mt-3 ps-4 pe-4">
            <div className="row mt-3 ">
              <div className="page-header">
                <div className="text-start  page-title" style={darkText}>
                  {mode === "en" ? "Company Profile" : "प्रोफाइल"}
                </div>
                <div className="page-date">
                  <div className="sec-content" style={darkText}>
                    <span className="me-2 ">Expires in: {expires} </span>
                    <FaRegCalendarAlt /> {todayDate} <span>|</span>{" "}
                    {mode === "en" ? "Fiscal Year" : "वित्तीय वर्ष"} :{" "}
                    {fiscalYear.StartDate}
                    {fiscalYear.EndDate}
                  </div>
                </div>
              </div>
              <hr className="title-hr" />
            </div>


            
    <div className="container-fluid mt-3">
      <div className="row">
        <div className="col-12">
          <div className="sec-dataTable">
           

            <div className="card-body">
              {/* Logo Row */}
              <div className="row mb-4 align-items-center">
               
                <div className="col-md-12">
                  <div className="d-flex align-items-center gap-3">
                    <img
                      src={formData.Logo || placeholderLogo}
                      alt="School Logo"
                      style={{ width: "100px", height: "80px", objectFit: "contain", border: "1px solid #e0e0e0", borderRadius: "8px", padding: "4px" }}
                      onError={(e) => (e.target.src = placeholderLogo)}
                    />
                    {/* <button type="button" className="btn btn-sm btn-outline-secondary" disabled>
                      {mode === "en" ? "Upload Image" : "तस्बिर अपलोड गर्नुहोस्"}
                    </button> */}
                   
                  </div>
                </div>
              </div>

              {/* School Name */}
              <div className="row mb-3">
                <div className="col-md-2">
                  <label className="fw-bold">
                    {mode === "en" ? "Company Name" : "विद्यालयको नाम"} <span className="text-danger">*</span>
                  </label>
                </div>
                <div className="col-md-10">
                  <input
                    type="text"
                    name="ComName"
                    disabled
                    className={`form-control ${formErrors.ComName ? "is-invalid" : ""}`}
                    value={formData.ComName}
                    onChange={handleChange}
                  />
                  {formErrors.ComName && <div className="invalid-feedback">{formErrors.ComName}</div>}
                </div>
              </div>

              {/* Address + District */}
              <div className="row mb-3">
                <div className="col-md-2">
                  <label className="fw-bold">
                    {mode === "en" ? "Address" : "ठेगाना"} <span className="text-danger">*</span>
                  </label>
                </div>
                <div className="col-md-4">
                  <input
                    type="text"
                    name="Address"
                    className={`form-control ${formErrors.Address ? "is-invalid" : ""}`}
                    value={formData.Address}
                    onChange={handleChange}
                  />
                  {formErrors.Address && <div className="invalid-feedback">{formErrors.Address}</div>}
                </div>



                 <div className="col-md-2">
                  <label className="fw-bold">
                    {mode === "en" ? "District" : "ठेगाना"} <span className="text-danger">*</span>
                  </label>
                </div>
                <div className="col-md-4">
                  <select
                    name="DistrictID"
                    className={`form-select ${formErrors.DistrictID ? "is-invalid" : ""}`}
                    value={formData.DistrictID}
                    onChange={handleChange}
                  >
                    <option value="">{mode === "en" ? "Select District" : "जिल्ला छान्नुहोस्"}</option>
                    {districtOptions.map((dist) => (
                      <option key={dist.id} value={dist.id}>
                        {dist.name}
                      </option>
                    ))}
                  </select>
                  {formErrors.DistrictID && <div className="invalid-feedback">{formErrors.DistrictID}</div>}
                </div>


              </div>

            

              {/* Latitude + Longitude */}
              <div className="row mb-3">
                <div className="col-md-2">
                  <label className="fw-bold">{mode === "en" ? "Latitude" : "अक्षांश"}</label>
                </div>
                <div className="col-md-4">
                  <input type="text" name="Latitude" className="form-control" value={formData.Latitude} onChange={handleChange} />
                </div>
                <div className="col-md-2">
                  <label className="fw-bold">{mode === "en" ? "Longitude" : "देशान्तर"}</label>
                </div>
                <div className="col-md-4">
                  <input type="text" name="Longitude" className="form-control" value={formData.Longitude} onChange={handleChange} />
                </div>
              </div>

              {/* Website + Facebook */}
              <div className="row mb-3">
                <div className="col-md-2">
                  <label className="fw-bold">{mode === "en" ? "Website" : "वेबसाइट"}</label>
                </div>
                <div className="col-md-4">
                  <input type="text" name="Website" className="form-control" value={formData.Website} onChange={handleChange} />
                </div>
                <div className="col-md-2">
                  <label className="fw-bold">{mode === "en" ? "Facebook" : "फेसबुक"}</label>
                </div>
                <div className="col-md-4">
                  <input type="text" name="Fb" className="form-control" value={formData.Fb} onChange={handleChange} />
                </div>
              </div>

              {/* Email + Telephone + Mobile (optional but present in API) */}
              <div className="row mb-3">
                <div className="col-md-2">
                  <label className="fw-bold">{mode === "en" ? "Email" : "इमेल"}</label>
                </div>
                <div className="col-md-4">
                  <input type="email" name="Email" className={`form-control ${formErrors.Email ? "is-invalid" : ""}`} value={formData.Email} onChange={handleChange} />
                  {formErrors.Email && <div className="invalid-feedback">{formErrors.Email}</div>}
                </div>
                <div className="col-md-2">
                  <label className="fw-bold">{mode === "en" ? "Telephone" : "टेलिफोन"}</label>
                </div>
                <div className="col-md-4">
                  <input type="text" name="Tel" className="form-control" value={formData.Tel} onChange={handleChange} />
                </div>
              </div>
              <div className="row mb-3">
                <div className="col-md-2">
                  <label className="fw-bold">{mode === "en" ? "Mobile Number" : "मोबाइल नम्बर"}</label>
                </div>
                <div className="col-md-4">
                  <input type="text" name="MobNumber" className="form-control" value={formData.MobNumber} onChange={handleChange} />
                </div>
                <div className="col-md-2">
                  <label className="fw-bold">{mode === "en" ? "SSF No." : "एसएसएफ नम्बर"}</label>
                </div>
                <div className="col-md-4">
                  <input type="text" name="SSFNo" className="form-control" value={formData.SSFNo} onChange={handleChange} />
                </div>
              </div>
              <div className="row mb-3">
                <div className="col-md-2">
                  <label className="fw-bold">{mode === "en" ? "Provident Fund" : "भविष्य कोष"}</label>
                </div>
                <div className="col-md-4">
                  <input type="text" name="ProvFund" className="form-control" value={formData.ProvFund} onChange={handleChange} />
                </div>

                  <div className="col-md-2">
                  <label className="fw-bold">{mode === "en" ? "Expiry date" : "भविष्य कोष"}</label>
                </div>
                <div className="col-md-4">
                  <input type="text" name="ExpiryDate" disabled className="form-control" value={formData.ExpiryDate} onChange={handleChange} />
                </div>

              </div>

              {/* Action Buttons */}
              <div className="row mt-4">
                <div className="col-md-12">
                  <button
                    className="btn btn-primary me-2"
                    onClick={handleSave}
                    disabled={saving}
                    style={{ minWidth: "120px" }}
                  >
                    {saving ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                        Saving...
                      </>
                    ) : (
                      <>
                        <FaRegSave className="me-1" /> {mode === "en" ? "Save Changes" : "परिवर्तन सुरक्षित गर्नुहोस्"}
                      </>
                    )}
                  </button>
                  <button className="btn btn-outline-secondary" onClick={fetchSchoolData} disabled={saving}>
                    <FaSyncAlt className="me-1" /> {mode === "en" ? "Refresh" : "रिफ्रेस"}
                  </button>
                </div>
              </div>
            </div>

           
          </div>
        </div>
      </div>
      <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} />
    </div>
    </div>
  );
}